import { ApiSanctionType, ApiScreeningDirection, ApiScreeningTest } from '../../api';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';

export type InverseScreeningSource = 'DOW_JONES' | 'CUSTOM_LIST' | 'ALL';

export const DOW_JONES_TYPES = [
  ApiSanctionType.SANCTION,
  ApiSanctionType.PEP,
  ApiSanctionType.ADVERSE_MEDIA,
  ApiSanctionType.ADVERSE_MEDIA_ENTITY,
];

export const getInverseScreeningSource = (test: ApiScreeningTest): InverseScreeningSource | undefined => {
  if (test.screeningDirection !== ApiScreeningDirection.INVERSE) {
    return undefined;
  }
  if (test.screeningListType == null) {
    return 'ALL';
  }
  return test.screeningListType === ApiSanctionType.CUSTOM_SCREENING_LIST ? 'CUSTOM_LIST' : 'DOW_JONES';
};

export interface InverseWireFields {
  screeningListType?: ApiSanctionType;
  customListCode?: string;
  recordExternalIds?: string[];
}

export interface InverseFormInput {
  screeningDirection?: ApiScreeningDirection;
  inverseSource?: InverseScreeningSource;
  screeningListType?: DropdownOption;
  customListCode?: DropdownOption;
  recordExternalIds?: string[];
}

export const getInverseScreeningValues = (values: InverseFormInput): InverseWireFields => {
  if (values.screeningDirection !== ApiScreeningDirection.INVERSE) {
    return {};
  }
  switch (values.inverseSource) {
    case 'CUSTOM_LIST':
      return {
        screeningListType: ApiSanctionType.CUSTOM_SCREENING_LIST,
        customListCode: values.customListCode?.value as string | undefined,
        recordExternalIds: values.recordExternalIds,
      };
    case 'DOW_JONES':
      return {
        screeningListType: values.screeningListType?.value as ApiSanctionType | undefined,
        recordExternalIds: values.recordExternalIds,
      };
    default:
      return {};
  }
};
